import { render } from "./PersonDialog.vue?vue&type=template&id=397509b7"
import script from "./PersonDialog.vue?vue&type=script&lang=js"
export * from "./PersonDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__